import Metadata from '../../../requests/apa/Metadata';
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';
import Utils from '../../../utils/Utils';
import logger from 'src/utils/logger/logger';

let shakaDebugMode = null;
let shaka = null;

const init = function() {
  try {
    shakaDebugMode = false;
    const meta = Metadata.get(
      'shaka_player_debug_mode',
      '{"default":{"enable":false}, "chile":{"enable":false}}'
    );
    const objectMeta = JSON.parse(meta);

    var _region = DeviceStorage.getItem('region');
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
    if (value && typeof value == 'object' && value.enable) {
      shakaDebugMode = value.enable;
    }
  } catch (e) {
    shakaDebugMode = false;
  }
};

const getShakaObject = function() {
  if (shakaDebugMode === null) {
    init();
  }

  if (shaka !== null) {
    return shaka;
  }

  if (!shakaDebugMode) {
    logger.debug('[SHAKA] Se importa shaka en debug mode');
    const _shaka = require('shaka-player/dist/shaka-player.compiled.debug');
    if(Utils.isNotNullOrNotUndefined(_shaka.shaka)) {
      shaka = _shaka.shaka;
    }
    else {
      shaka = _shaka;
    }
  } else {
    logger.debug('[SHAKA] Se importa shaka en prod mode');
    shaka = require('shaka-player');
  }

  shaka.polyfill.installAll();

  return shaka;
};

const ShakaLib = {
  init,
  getShakaObject
};

export default ShakaLib;



// WEBPACK FOOTER //
// ./src/devices/all/shakaPlayer/ShakaLib.js